function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.6308589mm",
    height: "7.6826172mm",
    viewBox: "0 0 4.6308589 7.6826172",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.467935,-58.190024)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 22.010906,64.421463 q 0.209961,0.175781 0.483398,0.263672 0.27832,0.08789 0.615235,0.08789 0.786132,0 1.298828,-0.375977 0.512695,-0.375977 0.512695,-0.9375 0,-0.493164 -0.361328,-0.761719 -0.361328,-0.268554 -1.176758,-0.375976 -0.136719,-0.01953 -0.366211,-0.03906 -0.585937,-0.04883 -0.585937,-0.3125 0,-0.258789 0.483398,-0.366211 0.06836,-0.01465 0.107422,-0.02441 0.947266,-0.205078 1.37207,-0.517578 0.424805,-0.317383 0.424805,-0.810547 0,-0.439453 -0.341797,-0.698242 -0.341797,-0.263672 -0.917969,-0.263672 -0.371093,0 -0.668945,0.126953 -0.297852,0.126953 -0.541992,0.385742 -0.170899,-0.12207 -0.253906,-0.249023 -0.08301,-0.126953 -0.08301,-0.273438 0,-0.356445 0.449218,-0.595703 0.449219,-0.24414 1.157227,-0.24414 0.957031,0 1.542969,0.463867 0.59082,0.463867 0.59082,1.206055 0,0.629882 -0.444336,1.074218 -0.439453,0.444336 -1.25,0.625 0.913086,0.19043 1.352539,0.585938 0.439453,0.395508 0.439453,1.02539 0,0.927735 -0.864257,1.567383 -0.864258,0.634766 -2.158204,0.634766 -0.551757,0 -0.830078,-0.141602 -0.27832,-0.146484 -0.27832,-0.429687 0,-0.12207 0.06836,-0.273438 0.07324,-0.151367 0.22461,-0.356445 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit3);
export default __webpack_public_path__ + "static/media/digit-3.b1c76fee29c72831b71b4c30464004bc.svg";
export { ForwardRef as ReactComponent };